export default __webpack_public_path__ + "static/AppLocation6-ae29b95d44f7ed2b8f6c906c4647aa0e.png";